/*
* AdaliaMeDatagridColumnConfigurator component specific for Adalia M&E.
*
* Sets up the datagrid components. When the component is dropped, a dialog will appear for the user to choose which grid, column or preset to load
*/

import React from 'react';
import * as FormComponent from '../form_components.jsx';

import Helpers from './helpers.jsx';
import {
  Base,
  AdaliaDatagridRowUpdater,
  AdaliaMeDatagridPrefilGroupsRepeatable,
  AdaliaMeDatagridPrefilGroupsDropdown,
  AdaliaMeDatagridCalculatedRowUpdater,
  OptionalRegion,
  RepeatableRegion,
} from '../form_components.jsx';

import Select from '../../common/Select.jsx';
import { Modal, closeModal } from '../../common/Modal.jsx';

export default class AdaliaMeDatagridColumnConfigurator extends Base {

  static get CATEGORY() {
    return 'question';
  }

  static get TYPE() {
    return 'adalia_me_datagrid_column_configurator';
  }

  static get TRANSLATED_ATTRIBUTES() {
    return {
      label: 'component_title_adalia_me_datagrid_column_configurator',
      description: 'field_default_description',
      help: null
    };
  }

  static icon() {
    return <i className='fa fa-columns'></i>;
  }

  static targetContent = null;

  static dropAllowed(dropArea, droppedContent, components, isNested) {
    AdaliaMeDatagridColumnConfigurator.targetContent = dropArea;
    return super.dropAllowed(dropArea, droppedContent, components, isNested);
  }

  constructor(props) {
    super(props);
    this.datagridComponents = JSON.parse(this.props.content.datagridComponents);
    this.state = {
      saving: false,
      selectedValue: null,
      datagridColOptions: this.datagridComponents['cols'].map(v => ({
        value: (v.colId || v.presetId),
        label: v.translations[I18n.locale]['label'],
        component: v.component
      }))
    }
  }

  getDroppedComponentContent() {
    let defaultComponentContent = this.datagridComponents['cols'].find(v => v.colId == this.state.selectedValue || v.presetId == this.state.selectedValue)
    let c = FormComponent[defaultComponentContent.component];
    let droppedContent = Object.assign(c.defaultContent(this.props.language), defaultComponentContent);
    droppedContent.id = 'id-'+ Helpers.randomString();
    droppedContent.datagridId = this.props.content.datagridId;
    droppedContent.datagridName = this.props.content.datagridName;
    droppedContent.cloneable = false;
    droppedContent.component = null;

    return droppedContent;
  };

  handleClose = () => {
    if (!this.state.saving) this.props.deleteComponentCallback(this.props.content.id);
    closeModal('column-configurator-modal-id');
  };

  handleSubmit = (e) => {
    let droppedContent = this.getDroppedComponentContent()
    let updatedDroppedContent = this.dropAllowed(droppedContent)

    if (updatedDroppedContent) {
      this.setState({saving: true}, () => {
        this.props.replaceComponentContent(this.props.content.id, updatedDroppedContent);
        this.props.selectCallback(updatedDroppedContent)
        this.handleClose();
      });
    } else {
      this.handleClose();
    }

    e.preventDefault();
  };

  dropAllowed(droppedContent) {
    if (AdaliaMeDatagridColumnConfigurator.targetContent.length == undefined) {
      let componentId = AdaliaMeDatagridColumnConfigurator.targetContent.getAttribute('data-component-id')
      let targetContent = this.props.findComponentsCallback({id: componentId})[0];

      if (targetContent.type == AdaliaMeDatagridPrefilGroupsRepeatable.TYPE) {
        if ([AdaliaMeDatagridPrefilGroupsRepeatable.TYPE, RepeatableRegion.TYPE, OptionalRegion.TYPE, AdaliaDatagridRowUpdater.TYPE].includes(droppedContent.type))
          return false;
      }

      if (targetContent.type == AdaliaMeDatagridCalculatedRowUpdater.TYPE) {
        if (droppedContent.datagridId && !droppedContent.name.includes('datagrid_calculated_row')) {
          let name = `datagrid_calculated_row-${droppedContent.datagridId}-${droppedContent.name}`;
          if (droppedContent.rows && droppedContent.rows[0])
            droppedContent.rows[0][0].component.name = name;
          else
            droppedContent.name = name;
        }

      } else if (targetContent.hasOwnProperty('rowGroupCols')) {
        if (droppedContent.type == AdaliaMeDatagridPrefilGroupsRepeatable.TYPE) {
          return false;

        } else if (droppedContent.hasOwnProperty('colId') && targetContent.datagridId == droppedContent.datagridId) {
          droppedContent.rowGroupCols = targetContent.rowGroupCols;
          droppedContent.presetId = targetContent.presetId;
          droppedContent.readOnly = true;

          if (droppedContent.rowGroupCols.includes(droppedContent.colAccessor)) {
            droppedContent.type = AdaliaMeDatagridPrefilGroupsDropdown.TYPE;
            droppedContent.options = [];
          }
        }
      }
    }

    return droppedContent;
  }

  handleValueChange = (value) => {
    this.setState({selectedValue: value});
  };

  renderView() {
    return (
      <Modal
        id={'column-configurator-modal-id'}
        title={I18n.t('component_title_adalia_me_datagrid_column_configurator', {scope: 'fe'})}
        size='md'
        onSave={this.handleSubmit}
        onClose={this.handleClose}
        cancelLabel={I18n.t('close')}
        modalContainerClassName={'opacity-full'}
      >
        <div>
          <div className='form-group'>
            <label>{I18n.t('datagrid')}</label>
            <div className='form-control'>{this.datagridComponents['name']}</div>
          </div>

          <div className='form-group'>
            <label>{I18n.t('column')}/{I18n.t('preset')}</label>
            <Select
              options={this.state.datagridColOptions}
              onChange={(val) => this.handleValueChange(val)}
              autoComplete={this.getAutoComplete()}
            />
          </div>
        </div>
      </Modal>
    );
  }

  renderSettings() {
    return <></>
  }
}
